import { Box, Brand, BODY_INK, LogoAt, Page, Text } from "../primitives";
/** Reference page 8 — «الرؤية» / «الرسالة». Line breaks fixed to the reference. */
const VISION = [
    { top: 299, text: "نحن لا نقدّم لوحات جاهزة فحسب، بل نوفّر حلولاً فنية مصمّمة خصيصًا، ينفّذها فريق من المعماريين والمصممين" },
    { top: 326, text: "المحترفين، لضمان انسجام كل عمل فني مع طبيعة المشروع وذوق كل عميل على حدة." },
];
const MISSION = [
    { top: 397, text: "نحن لا نصنع مجرد لوحة، بل نخلق تجربة فنية تبدأ بفهم المكان وذوق العميل.نرافق المعماريين وأصحاب المشاريع في" },
    { top: 423, text: "رحلتهم من الفكرة إلى التنفيذ، لنحوّل رؤاهم الفنية إلى أعمال ملموسة تجمع بين الجمال والوظيفة. يضم فريقنا خبرات" },
    { top: 449, text: "في العمارة والتصميم والفن، ويجمع بين التكنولوجيا المتقدمة واللمسة الإنسانية الراقية، لنضع توقيع أرتيكا في كل" },
    { top: 474, text: "عمل، فيصبح جزءًا من المكان. ومن الشخص نستمع، نحلّل، نختار، وننفّذ — لنقدّم أعمالاً فنية تنسجم مع المكان" },
    { top: 500, text: "وتلامس الإنسان. نمنح الفن دقة التكنولوجيا وروح الإنسان." },
];
function Paragraph({ lines }) {
    return (<>
      {lines.map((line, i) => (<Text key={i} right={813} top={line.top} size={17} weight={400} color={BODY_INK} width={766} justify={i < lines.length - 1}>
          {line.text}
        </Text>))}
    </>);
}
export function VisionMissionPage() {
    return (<Page>
      <LogoAt cx={64.45} cy={109.65} w={31.95}/>
      <Brand right={1081} top={80} size={34}/>

      <Text right={1083} top={285} size={43} weight={700}>
        الرؤية
      </Text>
      <Paragraph lines={VISION}/>

      <Box x={40.5} y={367.6} w={1048.5} h={1.3} style={{ background: "#545454" }}/>

      <Text right={1084} top={391} size={43} weight={700}>
        الرسالة
      </Text>
      <Paragraph lines={MISSION}/>
    </Page>);
}
